export default __webpack_public_path__ + "static/media/wildfangz-closed.db2006a4.png";